import Vue from 'vue'
import App from '@/recentDiscussions/App.vue'
import { Blue } from '!/js/core';
import VueMoment from 'vue-moment';

Vue.config.devtools = true
Vue.config.productionTip = false

const props = {};
const util = new Blue(props);

util.ready('mount_recent_discussions', '[recent-discussions]', el => {
	let data = {};
	const type = el.getAttribute('recent-discussions');
	if(type === 'widget')
	{
		const communityId = el.getAttribute('community-id');
		const title = el.getAttribute('title');
		data = {
			communityId: communityId,
			title: title
		};
	}
	else
	{
		const ctaText = el.getAttribute('cta-text');
		const ctaUrl = el.getAttribute('cta-url');
		data = {
			ctaText: ctaText,
			ctaUrl: ctaUrl
		};
	}

	Vue.use(VueMoment);

	const app = new Vue({
		render: h => h(App,
			{
				props: {
					type: type,
					data: data
				}
			})
	});
	app.$mount(el)
})